import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from "moment";
import { CsvDownload } from '@/types/APIResponse';
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import PlantingModal from '@/assets/common/Modal/PlantingModal/PlantingModal.vue';
import { changeNumberFormat } from '@/assets/common/services';
import { LoginUser } from "@/types/Component";

@Component({
    components: {
        EmptyGraphMessage,
        PlantingModal
    },
    filters: {
        changeNumberFormat
    },
})
export default class PlantingList extends Vue {
    screen = 'PLANTINGLIST';
    baseUrl = '/planting_list';
    plantingList =  [] as any[];
    selectScreenManagement = '/graphScreenManagement';
    selectedCropOrPlantingId : string | null = null;
    selectedPlantingOrCropName = "";
    private selectedAgriFieldId : string | null = null;
    selectedAgriFieldName = "";
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    includeHiddenFlag = false;
    private selectedPlantingsOrCrops = 0;
    private lastSetOption = false;
    private agriFields = [] as any[];
    private plantings = [];
    private crops = [];
    private plantingsOrCrops = [] as any[];
    private pageSize = 1000;
    sortOrder = true;
    private loading = false;
    private isButtonDisabled = false;
    private isShow = false;
    private isRefresh = false;
    private selectedPlantingId : string | null = null;
    private mode = '';

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    created() {
        this.loading=true;
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.getPlantingList(1)
        this.getAgriFields()
        this.getPlantings()
        this.getCrops()
    }

    getPlantingList(page: number) {
        this.$apiClient.doRequest('get', `${this.baseUrl}?page=${page}&pageSize=${this.pageSize}`).then(res => {
          this.plantingList = res.plantingList
          if(res.filterArray !=null){
          this.plantingsOrCrops = res.filterArray.cropId || this.lastSetOption ? this.crops : this.plantings
          this.selectedPlantingsOrCrops = res.filterArray.cropId || this.lastSetOption ? 1 : 0;
          this.selectedCropOrPlantingId = res.filterArray.cropId ? res.filterArray.cropId : res.filterArray.plantingId
          this.selectedAgriFieldId = res.filterArray.agriFieldId
          this.selectedStartDate = res.filterArray.displayFromDate ? res.filterArray.displayFromDate : ""
          this.selectedEndDate = res.filterArray.displayToDate ? res.filterArray.displayToDate : ""
          this.startDate = res.filterArray.displayFromDate ? res.filterArray.displayFromDate : ""
          this.endDate = res.filterArray.displayToDate ? res.filterArray.displayToDate : ""
          this.includeHiddenFlag = res.filterArray.includeHiddenFlag
          }
          this.loading = false;
          if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
            || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
            this.isButtonDisabled = true;
            this.plantingList = [];
          }else{
            this.isButtonDisabled = false;
          } 
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
            this.loading = false;
        })
    }

    getAgriFields() {
        this.$apiClient.doRequest('get', '/agri_fields?with_hidden=true').then((res) => {
            this.agriFields = res.agri_fields
        })        
    }

    getPlantings() {
        this.$apiClient.doRequest('get', '/plantings?with_hidden=true').then((res) => {
            this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        })
    }

    getCrops() {
        this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
            this.crops = res.crops;
            this.crops.sort((a:any, b:any) => a.name.localeCompare(b.name));
            this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
            this.selectedPlantingOrCropName= this.plantingsOrCrops.find(item=>item.id==this.selectedCropOrPlantingId)?.name
            this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    handleSelectChange(flag = true) {
        this.selectedPlantingOrCropName = this.plantingsOrCrops.find(item=>item.id == this.selectedCropOrPlantingId)?.name
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id == this.selectedAgriFieldId)?.name

        if (this.selectedStartDate > this.selectedEndDate) {
            flag = false;
            this.plantingList = [];
            this.isButtonDisabled = true;
        }
        const params = {
          cropId: this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
          plantingId: !this.selectedPlantingsOrCrops ? this.selectedCropOrPlantingId : null,
          agriFieldId: this.selectedAgriFieldId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          screenName: this.screen,
          includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
            this.plantingList = [];
            this.loading = false;
        })
    } 
    
    handlePlantingsCropSelect () {
        this.plantingsOrCrops = !this.selectedPlantingsOrCrops ? this.plantings : this.crops
        this.selectedCropOrPlantingId=null
        this.lastSetOption = this.selectedPlantingsOrCrops ? true : false;
        this.handleSelectChange();
    }
    
    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
          this.selectedStartDate = this.startDate;
          this.selectedEndDate = this.endDate;
          this.isButtonDisabled = true
        } else {
          this.isButtonDisabled = false
          this.startDate = this.selectedStartDate;
          this.endDate = this.selectedEndDate;
        }
    }
    
    exportCsv() {
        this.$apiClient.getRequest( `${this.baseUrl}/csv_export?&start_date=${this.selectedStartDate}&end_date=${this.selectedEndDate}&crop_or_planting=${this.selectedPlantingOrCropName?this.selectedPlantingOrCropName:""}&agri_field_name=${this.selectedAgriFieldName?this.selectedAgriFieldName:""}&is_admin=${this.isAdmin}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }
    
    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled==false){
            const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
            const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
            const offset = (action === 'previous') ? -daysDifference : daysDifference;
            this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
            this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
            this.handleSelectChange();
        } else {
            this.isButtonDisabled = false
        }
    }
    
    handleScroll() {
        const dataTableBox = this.$refs.dataTableBox as HTMLDivElement;
        const bottomOffset = 20;
        if (dataTableBox.scrollTop + dataTableBox.clientHeight >= dataTableBox.scrollHeight - bottomOffset) {
          const currentPage = Math.ceil(this.plantingList.length / this.pageSize) + 1;
          this.getPlantingList(currentPage);
        }
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ? 
        numberToFormat.toLocaleString(undefined, {
            minimumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0,
            maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
        }) 
        : '';
    }
    
    sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.plantingList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
    }

    openPlantingModal(id = null, mode = '') {
        this.selectedPlantingId = id;
        this.mode = mode;
        this.isShow = true;
        this.$root.$emit('header-inert', true)
        this.$emit('list-planting-inert', true)
    }

    closePlantingModal() {
        this.selectedPlantingId = null;
        this.mode = ''
        this.isShow = false;
        this.$root.$emit('header-inert', false)
        this.$emit('list-planting-inert', false)
    }

    refreshTable () {
        this.plantingList = []
        this.loading = true
        this.getPlantingList(1);
    }

    moveToWorkList (id: string, from: string, to: string) {
        const params = {
            plantingId: id,
            agriFieldId: null,
            selectedWorkId: null,
            userId: null,
            startDate: moment(from).format('YYYY-MM-DD'),
            endDate: moment(to).format('YYYY-MM-DD'),
            workKind: "ACTUAL",
            screenName: "WORKRECORDLIST",
        };
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            this.$router.push('/list/work').then(() => { return })
        }).catch(error=>{
            this.$toasted.error('リクエストに失敗しました。')
        })
    }

    moveToHarvestList (id: string, from: string, to: string) {
        const params = {
            cropId: null,
            plantingId: id,
            agriFieldId: null,
            measurementTimingId: null,
            startDate: moment(from).format('YYYY-MM-DD'),
            endDate: moment(to).format('YYYY-MM-DD'),
            screenName: "HARVESTLIST",
        };
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            this.$router.push('/list/harvest').then(() => { return })
        }).catch(error=>{
            this.$toasted.error('リクエストに失敗しました。')
        })
    }
    
    get filterAgrifields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }      

    get filterPlantingsOrCrops() {
        if (this.selectedPlantingsOrCrops) {
            return this.plantingsOrCrops
        } else {
            return this.includeHiddenFlag ? this.plantingsOrCrops : this.plantingsOrCrops.filter(p => this.selectedCropOrPlantingId == p.id || !p.is_hidden);
        }
    }

}